import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=7d18d062&scoped=true"
import script from "./Sport.vue?vue&type=script&lang=js"
export * from "./Sport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d18d062",
  null
  
)

export default component.exports